import { Role } from "../user/user.types";

export const navigationConfig = [
  {
    roles: [Role.SuperAdmin, Role.Admin, Role.TeamLeader, Role.EquipmentDriver, Role.TruckDriver, Role.Manager, Role.WorkshopManager, Role.HumanResources, Role.Employee],
    title: 'Accueil',
    icon: 'heroicons_solid:home',
    subtitle: '',
    tooltip: 'Accueil',
    link: 'dashboard',
    id: 'dashboard',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  // {
  //   roles: [Role.Admin, Role.SuperAdmin],
  //   title: 'Interventions',
  //   icon: 'heroicons_solid:clipboard',
  //   link: 'interventions',
  //   tooltip:'Interventions',
  //   id: 'interventions',
  //   type: 'basic',
  //   canDelete: false,
  //   children: [],
  //   modules: [
  //     'interventions'
  //   ]
  // },
  // {
  //   roles: [Role.Admin, Role.SuperAdmin],
  //   title: 'Contrats',
  //   icon: 'heroicons_solid:document-text',
  //   link: 'contrats',
  //   tooltip:'Contrats',
  //   id: 'contrats',
  //   type: 'basic',
  //   canDelete: false,
  //   children: [],
  //   modules: [
  //     'contrats'
  //   ]
  // },
  // {
  //   title: 'Clients',
  //   icon: 'heroicons_solid:briefcase',
  //   subtitle: '',
  //   link: 'clients',
  //   tooltip: 'Clients',
  //   id: 'clients',
  //   type: 'basic',
  //   canDelete: false,
  //   children: [],
  // },
  // {
  //   roles: [Role.Admin, Role.SuperAdmin],
  //   title: 'Plannifications',
  //   icon: 'heroicons_solid:calendar',
  //   subtitle: '',
  //   link: 'plannification',
  //   tooltip: 'Plannifications',
  //   id: 'plannifications',
  //   type: 'basic',
  //   canDelete: false,
  //   children: [],
  //   modules: [
  //     'interventions'
  //   ]
  // },
  {
    roles: [Role.Admin, Role.Manager, Role.SuperAdmin],
    title: 'Synthèse',
    icon: 'heroicons_solid:queue-list',
    subtitle: '',
    link: 'synthese',
    tooltip: 'Synthèse',
    id: 'synthese',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    roles: [Role.Mechanic],
    title: 'Saisies atelier',
    icon: 'heroicons_solid:pencil-square',
    subtitle: '',
    link: 'saisies-atelier',
    tooltip: 'Saisies atelier',
    id: 'saisies-atelier',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    roles: [Role.WorkshopManager, Role.Admin, Role.SuperAdmin],
    title: 'Synthèse atelier',
    icon: 'heroicons_solid:wrench-screwdriver',
    subtitle: '',
    link: 'synthese-atelier',
    tooltip: 'Synthèse atelier',
    id: 'synthese-atelier',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    roles: [Role.Manager, Role.Admin, Role.SuperAdmin],
    title: 'CDTX : Codes manquants',
    icon: 'heroicons_solid:clipboard-document-check',
    subtitle: '',
    link: 'synthese-cdtx',
    tooltip: 'CDTX : Codes manquants',
    id: 'synthese-cdtx',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    roles: [Role.SuperAdmin, Role.TeamLeader, Role.Admin],
    title: 'Pré-paie',
    icon: 'heroicons_solid:currency-euro',
    subtitle: '',
    link: 'prepaie',
    tooltip: 'Pré-paie',
    id: 'prepaie',
    type: 'basic',
    canDelete: false,
    children: [],
    modules: [
      'prepaie'
    ]
  },
  {
    roles: [Role.SuperAdmin, Role.Admin],
    title: 'Statistiques',
    icon: 'heroicons_solid:chart-bar',
    subtitle: '',
    link: 'statistiques',
    tooltip: 'Statistiques',
    id: 'statistiques',
    type: 'basic',
    canDelete: false,
    children: [],
    modules: [
      'statistiques'
    ],
    badge: {
      title: 'BETA',
      classes: 'px-2 bg-amber-400 text-amber-900 rounded-full'
    }
  },
  {
    roles: [Role.Admin, Role.SuperAdmin, Role.Manager],
    title: 'Export déblais',
    icon: 'heroicons_solid:truck',
    subtitle: '',
    link: 'export-deblais',
    tooltip: 'Export déblais',
    id: 'export-deblais',
    type: 'basic',
    canDelete: false,
    children: [],
  },
  {
    roles: [Role.Admin, Role.SuperAdmin, Role.TeamLeader],
    title: 'Gestion des congés',
    icon: 'heroicons_solid:lifebuoy',
    subtitle: '',
    link: 'conges-en-attente',
    tooltip: 'Gestion des congés',
    id: 'gestion-conges',
    type: 'basic',
    canDelete: false,
    children: [],
    modules: [
      'conges'
    ],
    // Pour TeamAndSiteLeader, nécessite une vérification dynamique via l'API
    requiresCongesManagerCheck: true,
  },
  {
    roles: [Role.Admin, Role.SuperAdmin],
    title: 'Configurations',
    icon: 'heroicons_solid:cog-8-tooth',
    tooltip: 'Configurations',
    subtitle: '',
    link: 'configurations',
    id: 'configurations',
    type: 'basic',
    canDelete: false,
    children: [],
  },
];